import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ResearchView from '../views/ResearchView.vue'
import CasesView from '../views/CasesView.vue'
import { updateMeta } from '../utils/meta'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    props: (route) => ({ lang: route.query.lang }),
    meta: {
      title: {
        tw: 'MOOOORE (M4ORE) — 全端 AI 技術品牌',
        en: 'MOOOORE (M4ORE) — Full-stack AI Technology Brand',
        jp: 'MOOOORE (M4ORE) — フルスタックAIテクノロジーブランド'
      },
      description: {
        tw: 'MOOOORE（M4ORE）是全端 AI 技術品牌，專注醫療 AI、商業智慧與運動科技，提供 AI 演算法、前後端系統完整交付。',
        en: 'MOOOORE (M4ORE) is a full-stack AI technology brand specializing in healthcare AI, business intelligence, and sports technology.',
        jp: 'MOOOORE（M4ORE）はヘルスケアAI、ビジネスインテリジェンス、スポーツテクノロジーに特化したフルスタックAIテクノロジーブランドです。'
      }
    }
  },
  {
    path: '/research',
    name: 'research',
    component: ResearchView,
    props: (route) => ({ lang: route.query.lang }),
    meta: {
      title: {
        tw: 'Research — MOOOORE (M4ORE)',
        en: 'Research — MOOOORE (M4ORE)',
        jp: 'Research — MOOOORE (M4ORE)'
      },
      description: {
        tw: 'MOOOORE 研究領域：醫療 AI、Med-GEMMA 模型應用、AIoT 系統研發。',
        en: 'MOOOORE research: healthcare AI, Med-GEMMA model applications, AIoT system development.',
        jp: 'MOOOORE研究分野：医療AI、Med-GEMMAモデル応用、AIoTシステム開発。'
      }
    }
  },
  {
    path: '/cases',
    name: 'cases',
    component: CasesView,
    props: (route) => ({ lang: route.query.lang }),
    meta: {
      title: {
        tw: 'Cases — MOOOORE (M4ORE)',
        en: 'Cases — MOOOORE (M4ORE)',
        jp: 'Cases — MOOOORE (M4ORE)'
      },
      description: {
        tw: 'MOOOORE 專案實績：ICU 聲音偵測 AIoT 系統、救護車 ECG 傳輸系統等全端 AI 交付案例。',
        en: 'MOOOORE delivered projects: ICU Sound Detection AIoT System, Ambulance ECG Transmission System, and more.',
        jp: 'MOOOORE実績：ICU音声検知AIoTシステム、救急車ECG伝送システムなど。'
      }
    }
  },
  // Paster link-in-bio 頁面
  {
    path: '/paster',
    name: 'paster',
    component: () => import('../views/paster/PasterView.vue'),
    meta: {
      hideNav: true,
      title: {
        tw: 'Paster — MOOOORE (M4ORE)',
        en: 'Paster — MOOOORE (M4ORE)',
        jp: 'Paster — MOOOORE (M4ORE)'
      },
      description: {
        tw: 'Paster — MOOOORE 連結頁面',
        en: 'Paster — MOOOORE link-in-bio page',
        jp: 'Paster — MOOOORE リンクページ'
      }
    }
  },
  // Partner 隱藏頁面
  {
    path: '/partner/:partnerId',
    name: 'partner',
    component: () => import('../views/partner/PartnerView.vue'),
    meta: { hideNav: true }
  },
  // Partner 沒有指定 partnerId 時導回首頁
  {
    path: '/partner',
    redirect: '/'
  },
  {
    path: '/partner/',
    redirect: '/'
  },
  // Product 影片頁面
  {
    path: '/product/:productId/:videoId',
    name: 'product-video',
    component: () => import('../views/product/VideoView.vue'),
    meta: { hideNav: true }
  },
  // Product 沒有完整路徑時導回首頁
  {
    path: '/product/:productId',
    redirect: '/'
  },
  {
    path: '/product/:productId/',
    redirect: '/'
  },
  {
    path: '/product',
    redirect: '/'
  },
  {
    path: '/product/',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',  // 使用 history 模式
  routes
})

router.afterEach((to) => {
  const lang = to.query.lang || 'tw'
  updateMeta(to, lang)
})

export default router
